import FloatingBtn from "../components/floatingBtn";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

function RootLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ behavior: "instant", top: 0 });
  }, [pathname]);

  return (
    <>
      <Outlet />
      <FloatingBtn />
    </>
  );
}

export default RootLayout;
